import { PageTitle, H2Heading } from "../../components/Headers";
import { PageBody } from "../../components/PageBody";
import { Helmet } from "react-helmet-async";
import { GridDiv, GridDivContainer } from "../../components/GridDiv";
import { ProjectLink } from "../../components/ProjectLink";
import { ArticleParagraph } from "../../components/Paragraphs";
import { getProjectsForSection } from "../../config/projects";
import { getSEOForPath } from "../../config/seo";
import { useLocation } from "react-router-dom";

// Get related betting projects (excluding the current page)
const relatedBettingProjects = getProjectsForSection('/betting').filter(
	project => !project.to.includes('understand-sports-betting')
);


export const UnderstandSportsBetting = () => {
    const location = useLocation();
    const seo = getSEOForPath(location.pathname);
    
    return (
        <PageBody>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description}></meta>
                {seo.keywords && <meta name="keywords" content={seo.keywords}></meta>}
                {seo.canonical && <link rel="canonical" href={seo.canonical} />}
            </Helmet>

            <PageTitle title="Understand Sports Betting: Build Intuition and Avoid Losing" />

            <ArticleParagraph
                lines={[
                    "Sports betting is commonplace in many parts of the world, but most people don’t really understand how it works or the process behind the odds that you see. Bookmakers make lots of money every day taking bets from customers by offering them odds, or a price, to risk money in return for the chance to win money.",
                    "It is sold as a viable chance of consistently making money, but betting on sports is risky, and even riskier if you don't build an intuition and understanding of what you are looking at.",
                    "Understanding sports betting, odds and pricing will enable you to realise what a good bet looks like, as well as how difficult they are to find. Thinking probabilistically and making a decision on what a good price is alongside the knowledge of how most bookmakers make it even more difficult to win by padding their prices with margin will make you a smarter, more savvy punter.",
                    "This doesn't mean that you have to build statistical models, but understanding the rules of the sports betting game that you're playing can help you control your decision making. Note that I say 'avoid losing'; that should be your first step. Making money requires other factors that I will also write about.",
                ]}
            />

            <H2Heading classes="mb-0">More Sports Betting</H2Heading>
            <GridDivContainer>
                {relatedBettingProjects.map((project) => (
                    <GridDiv
                        key={project.to}
                        widthClasses="w-full md:w-1/2"
                    >
                        <ProjectLink
                            to={project.to}
                            title={project.title}
                            icon={project.icon}
                            colorClass={project.colorClass}
                        />
                    </GridDiv>
                ))}
            </GridDivContainer>
        </PageBody>
    );
};
